import apiService from './apiService';

// Notify Instruction Add
export const notifyInstructionAdd = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/notify-instruction-add`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying instruction add:', error);
    throw error;
  }
};

// Mark Instruction Added
export const markInstructionAdd = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/mark-instruction-added`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking instruction as added:', error);
    throw error;
  }
};

// Notify Review
export const notifyReview = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/notify-review`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying review:', error);
    throw error;
  }
};

// Mark Reviewed
export const markReviewed = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/mark-reviewed`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking reviewed:', error);
    throw error;
  }
};

// Notify Support
export const notifySupport = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/notify-support`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying support:', error);
    throw error;
  }
};

// Mark Supported
export const markSupported = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/mark-supported`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking supported:', error);
    throw error;
  }
};

// Notify Authorize
export const notifyAuthorize = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/notify-authorize`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying authorize:', error);
    throw error;
  }
};

// Mark Authorized
export const markAuthorized = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/mark-authorized`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking authorized:', error);
    throw error;
  }
};

// Notify Acceptance
export const notifyAcceptance = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/notify-acceptance`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying acceptance:', error);
    throw error;
  }
};

// Mark Accepted
export const markAccepted = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/mark-accepted`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking accepted:', error);
    throw error;
  }
};

// Request Extension
export const requestExtension = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/request-extension`, payload);
    return response.data;
  } catch (error) {
    console.error('Error requesting extension:', error);
    throw error;
  }
};

// Approve Extension
export const approveExtension = async (extensionId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/extensions/${extensionId}/approve`, payload);
    return response.data;
  } catch (error) {
    console.error('Error approving extension:', error);
    throw error;
  }
};

// Reject Extension
export const rejectExtension = async (extensionId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/extensions/${extensionId}/reject`, payload);
    return response.data;
  } catch (error) {
    console.error('Error rejecting extension:', error);
    throw error;
  }
};

// Remove TOI
export const removeTOI = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/remove`, payload);
    return response.data;
  } catch (error) {
    console.error('Error removing TOI:', error);
    throw error;
  }
};
